<template>
    <div class="a-table--short-no-style">
        <table class="a-table a-table--full-width">
            <tr>
                <th></th>
                <th v-for="rate in rates">
                    {{rate}}
                </th>
                <th>Difference</th>
            </tr>
            <tr>
                <td>
                    Past Losses
                </td>
                <td v-for="index in rates.length">
                    {{ currencyFormat(data[index - 1][0].data[0]) }}
                </td>
                <td>
                    {{ currencyFormat(Math.abs(data[0][0].data[0] - data[1][0].data[0])) }}
                </td>
            </tr>
            <tr>
                <td>
                    Future Losses
                </td>
                <td v-for="index in rates.length">
                    {{ currencyFormat(data[index - 1][0].data[1]) }}
                </td>
                <td>
                    {{ currencyFormat(Math.abs(data[0][0].data[1] - data[1][0].data[1])) }}
                </td>
            </tr>
            <tfoot>
                <tr>
                    <td>
                        Total
                    </td>
                    <td v-for="index in rates.length">
                        {{currencyFormat(data[index - 1][0].data[1] + data[index - 1][0].data[0])}}
                    </td>
                    <td>
                        {{currencyFormat(Math.abs((data[0][0].data[0] - data[1][0].data[0]) - (data[0][0].data[1] - data[1][0].data[1])))}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import currencyFormat from "mixins/currencyFormat";

    export default {
        name: "pie-summary",
        mixins:[
            currencyFormat
        ],
        props: {
            rates:{
                type:Array,
                required: true
            },
            data: {
                type:Array,
                required:true
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// PieSummary.vue?1b0cb948